import { render, staticRenderFns } from "./vFormSLIDE_CONTROL.vue?vue&type=template&id=b0ffdfb4&"
import script from "./vFormSLIDE_CONTROL.vue?vue&type=script&lang=js&"
export * from "./vFormSLIDE_CONTROL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports